module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgMzAgNCI+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNjQiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE2NCIgd2lkdGg9IjMwIiBoZWlnaHQ9IjQiIGZpbGw9IiNmMTRjMjgiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_menos.svg
// module id = 1t6g
// module chunks = 1